import { Cloud, Code2, Rocket, Zap, Globe, Layout, Shield, Cpu } from 'lucide-react';

const FEATURES = [
    {
        icon: Cloud,
        title: 'Edge-Native Coding',
        description: 'Build apps that run instantly on Cloudflare\'s global network',
    },
    {
        icon: Code2,
        title: 'Vibe Implementation',
        description: 'Natural language to production-ready React + TypeScript',
    },
    {
        icon: Shield,
        title: 'Enterprise Security',
        description: 'Built-in protection with Cloudflare security standards',
    },
    {
        icon: Rocket,
        title: 'Instant Deployment',
        description: 'Zero-config deployment to the edge in seconds',
    },
];

export function WelcomeScreen() {
    return (
        <div className="flex-1 flex items-center justify-center p-8 pt-20 bg-grid overflow-y-auto">
            <div className="max-w-2xl text-center">
                {/* Logo */}
                <div className="inline-flex items-center justify-center w-24 h-24 rounded-3xl
                        bg-gradient-to-br from-accent-primary to-accent-secondary
                        shadow-glow-lg mb-8 relative group">
                    <Cloud className="w-12 h-12 text-white transition-transform group-hover:scale-110" />
                    <div className="absolute -inset-1 bg-accent-primary/20 blur-xl rounded-full -z-10 group-hover:bg-accent-primary/30 transition-all" />
                </div>

                {/* Heading */}
                <h1 className="text-5xl font-extrabold text-text-primary mb-4 tracking-tight">
                    Welcome to <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-primary to-accent-secondary">Vibeflare</span>
                </h1>
                <p className="text-xl text-text-secondary mb-12 max-w-lg mx-auto leading-relaxed">
                    The ultimate vibe coding platform, powered by Cloudflare. Describe your vision, and we'll handle the infrastructure.
                </p>

                {/* Features grid */}
                <div className="grid grid-cols-2 gap-6 mb-12">
                    {FEATURES.map((feature, i) => (
                        <div
                            key={i}
                            className="bg-surface/50 border border-border/50 rounded-2xl p-6 text-left hover:border-accent-primary/50 transition-all duration-300 group"
                        >
                            <div className="w-12 h-12 rounded-xl bg-background-tertiary flex items-center justify-center mb-4 group-hover:bg-accent-primary/10 transition-colors">
                                <feature.icon className="w-6 h-6 text-accent-primary" />
                            </div>
                            <h3 className="font-bold text-text-primary mb-2">{feature.title}</h3>
                            <p className="text-sm text-text-secondary leading-relaxed">{feature.description}</p>
                        </div>
                    ))}
                </div>

                {/* Call to action */}
                <div className="bg-surface/30 border border-border/30 rounded-3xl p-8 backdrop-blur-sm">
                    <p className="text-text-primary font-medium mb-4">
                        Ready to build the future of the web?
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
                        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-tertiary border border-border text-text-secondary">
                            <Globe className="w-4 h-4 text-accent-blue" />
                            Cloudflare Workers
                        </span>
                        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-tertiary border border-border text-text-secondary">
                            <Cpu className="w-4 h-4 text-accent-primary" />
                            Edge Runtime
                        </span>
                        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-tertiary border border-border text-text-secondary">
                            <Zap className="w-4 h-4 text-accent-secondary" />
                            Zero Latency
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
